<template>
  <div class="recovery-codes">
    <p class="recovery-intro">{{ $t('mfa.recovery.intro') }}</p>
    <ul class="recovery-list">
      <li v-for="code in codes" :key="code">{{ code }}</li>
    </ul>
    <div class="recovery-actions">
      <button type="button" class="recovery-btn" @click="copy">
        <i class="fa-regular fa-copy"></i> {{ copied ? $t('mfa.recovery.copied') : $t('mfa.recovery.copy') }}
      </button>
      <button type="button" class="recovery-btn" @click="download">
        <i class="fa-solid fa-download"></i> {{ $t('mfa.recovery.download') }}
      </button>
    </div>
    <label class="recovery-saved">
      <input type="checkbox" v-model="saved" />
      {{ $t('mfa.recovery.saved') }}
    </label>
    <button type="button" class="recovery-continue" :disabled="!saved" @click="$emit('done')">
      {{ $t('mfa.recovery.continue') }}
    </button>
  </div>
</template>

<script>
// Codes de secours affichés une seule fois (activation, enrôlement, régénération)
export default {
  name: 'RecoveryCodes',
  props: {
    codes: { type: Array, required: true }
  },
  data() {
    return { saved: false, copied: false }
  },
  methods: {
    text() {
      return `Mashup Web - ${this.$t('mfa.recovery.file_title')}\n\n${this.codes.join('\n')}\n`
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.text())
        this.copied = true
      } catch (e) {
        this.copied = false
      }
    },
    download() {
      const url = URL.createObjectURL(new Blob([this.text()], { type: 'text/plain' }))
      const a = document.createElement('a')
      a.href = url
      a.download = 'mashup-web-recovery-codes.txt'
      a.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.recovery-codes {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.recovery-intro {
  margin: 0;
  font-size: 14px;
  color: #555e75;
}
.recovery-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px 16px;
  margin: 0;
  padding: 12px 16px;
  list-style: none;
  background: #f8f8f8;
  border-radius: 8px;
  font-family: monospace;
  font-size: 15px;
  letter-spacing: 1px;
}
.recovery-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.recovery-btn {
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-radius: 20px;
  background: white;
  cursor: pointer;
  font-size: 13px;
}
.recovery-saved {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
}
.recovery-continue {
  height: 42px;
  border: 0;
  border-radius: 40px;
  background: #6b1f4d;
  color: white;
  font-size: 15px;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
